<a [routerLink]="link" (mousedown)="checkCtrlKey($event)"
   [state]="{disableRouterLink: disabled}" [queryParams]="queryParams">
  {{name}}
</a>